import React from "react";
import { TextField } from "@material-ui/core";
import "./messageChatInput.scss";

export default function MessageChatInput({
  value,
  onChange,
  onSend,
  sending = false,
  editing = false,
  onCancelEdit,
  placeholder = "Type a message… (Shift+Enter for new line)",
  className = "",
}) {
  return (
    <div className={`messages-chat-input-wrap ${className}`.trim()}>
      {editing ? (
        <div className="messages-editing-banner">
          <span>Editing message</span>
          <button
            type="button"
            className="messages-editing-cancel"
            onClick={onCancelEdit}
            disabled={sending}
          >
            Cancel
          </button>
        </div>
      ) : null}
      <div className="messages-chat-input">
        <TextField
          fullWidth
          multiline
          minRows={1}
          maxRows={8}
          variant="outlined"
          size="small"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={sending}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
        />
        <button
          type="button"
          className={`messages-send-icon-btn ${sending ? "is-sending" : ""}`}
          disabled={sending || !String(value || "").trim()}
          onClick={onSend}
          aria-label={editing ? "Save message" : "Send message"}
          title={editing ? "Save" : "Send"}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="messages-send-icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
